import './styles/ChangePassword.scss';
import { useContext, useState, useEffect } from 'react';
import { AppContext } from '../../Context';
import { useHistory } from 'react-router';

//controllers
import DatabaseInterfaceController from '../../controllers/DatabaseInterfaceController';

//mui icons
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { System_DeviceOrientationMap } from '../../assets/keyMap';

interface Props {

}

const ChangePassword: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    //states form vars
    const [oldPassword, SetOldPassword] = useState('');
    const [newPassword, SetNewPassword] = useState('');
    const [retypePassword, SetRetypePassword] = useState('');
    const [visibilities, SetVisibilities] = useState([false, false, false] as boolean[]);
    //router objs
    const history =  useHistory();

    //controllers
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);

    //watchers
    //watch for databaseResultAction
    useEffect(() => {
        if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                switch (mode) {
                    case 'updateUserPassword':
                        if (!JSON.stringify(res).includes('_false')) {
                            appContext.SetPopupMessage('Password changed successful!');
                            appContext.SetPopupButtons(['ok']);
                            appContext.SetPopupActions([() => {history.push('/Profile')}]);
                        } else {
                            appContext.SetPopupMessage('Password not changed!\nThe old password is incorrect.');
                            ResetForm();
                        }
                        break;
                }
            }

            switch (appContext.databaseActionModeQueue[0]) {
                case 'updateUserPassword':
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //ui functions
    const OnSubmitBtnClicked = () => {
        if (newPassword == retypePassword) {
            databaseInterfaceController.Queue('updateUserPassword', [
                ['updateUserPassword', 'true'],
                ['userID', appContext.user.userID],
                ['oldPassword', oldPassword],
                ['newPassword', newPassword]
            ]);
        } else {
            appContext.SetPopupMessage('New password and retype new password must be the same.');
        }
    }

    //exe functions
    const ResetForm = () => {
        SetOldPassword(''); SetNewPassword(''); SetRetypePassword(''); SetVisibilities([false, false, false]);
    }

    return (
        <div className={'ChangePassword ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : '')}>
            <div className='row-block'>
                <span className='row-title'>Old password</span>
                <div className='row-in-block'>
                    <input className='row-in' value={oldPassword} type={visibilities[0] ? 'text' : 'password'} onChange={(e: any) => { SetOldPassword(e.target.value); }} placeholder='your current password'/>
                    <button className='row-btn' onClick={() => SetVisibilities([!visibilities[0], visibilities[1], visibilities[2]])}>
                        {
                            visibilities[0] ?
                                <VisibilityIcon />
                                :
                                <VisibilityOffIcon />
                        }
                    </button>
                </div>
            </div>
            <div className='row-block'>
                <span className='row-title'>New password</span>
                <div className='row-in-block'>
                    <input className='row-in' value={newPassword} type={visibilities[1] ? 'text' : 'password'} onChange={(e: any) => { SetNewPassword(e.target.value); }} placeholder='your new password'/>
                    <button className='row-btn' onClick={() => SetVisibilities([visibilities[0], !visibilities[1], visibilities[2]])}>
                        {
                            visibilities[1] ?
                                <VisibilityIcon />
                                :
                                <VisibilityOffIcon />
                        }
                    </button>
                </div>
            </div>
            <div className='row-block'>
                <span className='row-title'>Retype new password</span>
                <div className='row-in-block'>
                    <input className='row-in' value={retypePassword} type={visibilities[2] ? 'text' : 'password'} onChange={(e: any) => { SetRetypePassword(e.target.value); }} placeholder='your new password'/>
                    <button className='row-btn' onClick={() => SetVisibilities([visibilities[0], visibilities[1], !visibilities[2]])}>
                        {
                            visibilities[2] ?
                                <VisibilityIcon />
                                :
                                <VisibilityOffIcon />
                        }
                    </button>
                </div>
            </div>
            <button className='submit-btn' onClick={() => OnSubmitBtnClicked()}>Update Changes</button>
        </div>
    )
}
export default ChangePassword;